import React from 'react';
import {
  Box,
  Typography,
  Paper
} from '@mui/material';

interface CashFlowTabProps {
  projectName: string;
}

const CashFlowTab: React.FC<CashFlowTabProps> = ({ projectName }) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          Przepływy pieniężne
        </Typography>
      </Box>

      <Paper elevation={0} sx={{ border: '1px solid #eee', borderRadius: 1, p: 2 }}>
        <Typography variant="body1" sx={{ textAlign: 'center', py: 4, color: 'text.secondary' }}>
          Przepływy pieniężne zostaną zaimplementowane w kolejnej wersji.
        </Typography>
      </Paper>
    </Box>
  );
};

export default CashFlowTab;
